/* TemplateResult twins of the two string-returning HTML helpers that F3
 * lit-html-converted views need (F3a convention #10 — see the conventions
 * block at the top of views/wiki.ts). Each twin mirrors its string
 * original's logic 1:1 — the original is cited above each — but returns a
 * lit ChildPart-safe value instead of a pre-escaped HTML string, so it can
 * be interpolated directly into a converted view's `html\`...\`` template
 * (`${chipT(...)}`) without lit double-rendering a string of markup as
 * escaped text.
 *
 * F3c END-STATE: the string originals (lib/format.ts's chip(), lib/
 * glossary.ts's tip()) are DELETED — their last consumers (views/search.ts,
 * views/timeline.ts) converted to chipT()/tipT() in this wave. chipT()/
 * tipT() below are the only implementations now; every converted view
 * across F3a/F3b/F3c uses them.
 */
import { html, nothing, type TemplateResult } from 'lit';
import { GLOSSARY } from './glossary.ts';

// Verbatim logic mirror of lib/format.ts's chip(text, cls):
//   export function chip(text: any, cls?: any): string {
//     return text ? `<span class="chip ${cls || ''}">${esc(text)}</span>` : '';
//   }
// `${esc(text)}` → `${text}` (lit escapes the child-position text binding);
// the `''` empty-output branch becomes `nothing` (F3a convention #7).
export function chipT(text: unknown, cls?: string): TemplateResult | typeof nothing {
  return text ? html`<span class="chip ${cls || ''}">${text}</span>` : nothing;
}

// Verbatim logic mirror of lib/glossary.ts's tip(term, label):
//   export function tip(term: any, label?: any): string {
//     const t = GLOSSARY[term]; const txt = label != null ? label : term;
//     return t ? `<span class="gloss" title="${esc(t)}">${esc(txt)}</span>` : esc(txt);
//   }
// `${esc(t)}` (attribute) and `${esc(txt)}` (text) both → bare bindings
// (lit escapes both positions); the no-tooltip branch returns the plain
// `txt` value rather than `esc(txt)` — a caller interpolating tipT(...) as
// a lit child gets the same auto-escaping lit gives every other plain
// string child.
export function tipT(term: string, label?: unknown): TemplateResult | unknown {
  const t = GLOSSARY[term]; const txt = label != null ? label : term;
  return t ? html`<span class="gloss" title="${t}">${txt}</span>` : txt;
}
